import NavigationMenu from '@/components/NavigationMenu'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styles from './Header.module.scss'

// Routes that render their own bespoke header; the global header is hidden on these.
const HIDDEN_HEADER_ROUTES = new Set(['/citgo', '/citgo/', '/motivation-technologies', '/motivation-technologies/'])

function Header() {
  const router = useRouter()

  // Strip the query string so preview URLs (?preview=true) still match.
  const path = router.asPath.split('?')[0]
  if (HIDDEN_HEADER_ROUTES.has(path)) {
    return null
  }

  return (
    <header className={styles.header}>
      <div className={styles.bar}>
        <div className={styles.logo}>
          <Link href="/" passHref>
            <Image src="/logo.png" width={130} height={44} alt="Integrity Web Consulting logo" loading="eager" />
          </Link>
        </div>

        <NavigationMenu />
      </div>
    </header>
  )
}

export default Header
